// /home/oh33090489/real-estate-app/frontend/src/auth/EmailLogin.jsx

import { useState } from "react";
import { loginEmail } from "../api/authApi";

function toast(msg){
  alert(msg); // 최소 구현 (나중에 toast lib 교체)
}

export default function EmailLogin({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleLogin() {
    setLoading(true);
    setError("");
    try {
      const res = await loginEmail(email, password);
      localStorage.setItem("token", res.token);
      toast("로그인 완료");
      onSuccess?.();            // 모달 닫기
      window.location.reload(); // Header 즉시 반영
    } catch (e) {
      setError("이메일 또는 비밀번호가 올바르지 않습니다.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-section">
      <div style={{ fontWeight: 600, marginBottom: 8 }}>이메일 로그인</div>
      <input
        placeholder="이메일"
        value={email}
        onChange={e=>setEmail(e.target.value)}
        style={{ width: "100%", marginBottom: 8 }}
        disabled={loading}
      />

      <div style={{ marginBottom: 8 }}>
        <label>
          <input type="checkbox" checked={showPw} onChange={e=>setShowPw(e.target.checked)} />
          비밀번호 표시
        </label>
      </div>

      <input
        placeholder="비밀번호"
        type={showPw ? "text" : "password"}
        value={password}
        onChange={e=>setPassword(e.target.value)}
        style={{ width: "100%", marginBottom: 12 }}
        disabled={loading}
      />
      {error && (
        <div style={{ color: "#dc2626", marginBottom: 8, fontSize: 13 }}>
          {error}
        </div>
      )}
      <button style={{ width: "100%" }} onClick={handleLogin}>
        {loading ? "로그인 중..." : "로그인"}
      </button>
    </div>
  );
}
